const Map = {
  trending: {
    1848: 5,
    1256: 3,
    576: 2,
    default: 1
  },
  user: {
    1848: 5,
    1256: 3,
    576: 2,
    default: 1
  },
  designers: {
    1848: 5,
    1256: 3,
    576: 2,
    default: 1
  },
  message: {
    1920: 4,
    1280: 3,
    1256: 2,
    default: 0,
  },
  buyers: {
    1920: 6,
    1280: 4,
    960: 3,
    default: 2
  },
  challenge: {
    1920: 6,
    1280: 4,
    960: 3,
    default: 2
  },
  community: {
    1920: 6,
    1280: 4,
    960: 3,
    default: 2
  },
  'wish-list': {
    1920: 6,
    1280: 4,
    960: 3,
    640: 2,
    default: 1
  },
  sale: {
    1920: 6,
    1280: 4,
    960: 3,
    default: 2
  },
  default: {
    1920: 6,
    1280: 4,
    960: 3,
    default: 2
  }
}

export { Map }
